export const COMMENTS_ORDER_BY = "localState:commentsOrderBy";

export const VIEWER_STATUS_CONTAINER_ID = "viewer-status";

export const POST_COMMENT_FORM_ID = "post-comment-form";

export const MAX_REPLY_INDENT_DEPTH = 7;

export const NUM_INITIAL_COMMENTS = 20;

export const RTE_ELEMENT_ID = "Coral-RTE";

export const NOTIFICATION_COMMENT_BODY_LENGTH = 120;

// eslint-disable-next-line no-shadow
export const enum URLViewType {
  IllegalContentReport = "illegalContentReport",
}
